import { render, staticRenderFns } from "./ticketCate.vue?vue&type=template&id=02fe43fe&scoped=true&"
import script from "./ticketCate.vue?vue&type=script&lang=js&"
export * from "./ticketCate.vue?vue&type=script&lang=js&"
import style0 from "./ticketCate.vue?vue&type=style&index=0&id=02fe43fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fe43fe",
  null
  
)

export default component.exports